var _polygon, _polygon2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPressure = function SvgPressure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "11.90685 14 9.95425 12.0474 8.78091 13.22074 7.15656 7.15656 13.22074 8.78091 12.0474 9.95425 14 11.90685 11.90685 14"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.84344 6.84344 .77926 5.21909 1.9526 4.04575 0 2.09315 2.09315 0 4.04575 1.9526 5.21909 .77926 6.84344 6.84344"
  })));
};

export default SvgPressure;